import { CardContent, TextField } from '@material-ui/core';
import FancyCard from '../../../components/fancy/FancyCard';
import React from 'react';

function PaymentFormCheck({ note, setNote }) {
    return (
        <FancyCard fullWidth>
            <CardContent>
                <h3 className="mb-2">Pay by Check</h3>
                <h5>The payment doesn&apos;t require credit card, you pay with check.</h5>
                <TextField
                    fullWidth
                    label="Note for the check"
                    name="cashnote"
                    placeholder="Note is required to identify the check itself."
                    type="text"
                    value={note}
                    onChange={ev => {
                        setNote(ev.target.value);
                    }}
                />
            </CardContent>
        </FancyCard>
    );
}

export default PaymentFormCheck;
